import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getRecordAllowancesOfProjectInTimeframe = async (
  projectId,
  timeframe
) => {
  const { fromDate, toDate } = timeframe;

  const apiPath = `record-allowances/project/${projectId}/${fromDate}/${toDate}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: false,
  });

  const response = await axios(signedRequest);

  return response.data;
};
